// Copied into your app by RapidRailsUI (bin/rails rui:update).
// Don't edit this copy: the next update overwrites it. Fix it in the rapid_rails_ui gem.
//
// Tooltip card placement for rui_chart, as pure arithmetic over measured boxes
// (all numbers in figure-relative px). The controller measures; this decides.
//
// Horizontal: centred on the anchor; if that would cross the plot's left edge
// (the y-axis labels) it sits to the right of the anchor, and to the left near
// the right edge. Always clamped inside the figure.
// Vertical: above the anchor; else below it when that does not land on the
// legend; else beside the anchor, centred on it (a 100% bar between a caption
// and a legend has room on neither side); else above the figure.

export function placeCard({ x, top, bottom }, { width, height, figureWidth, figureHeight, captionBottom = 0, legendBox = null, plotLeft = 0, plotRight = figureWidth }) {
  const clampX = (l) => Math.min(Math.max(l, 0), Math.max(figureWidth - width, 0))
  const overlaps = (y, box) => Boolean(box) && y < box.bottom && y + height > box.top

  let left = x - width / 2
  if (left < plotLeft) left = x + 12
  else if (left + width > plotRight) left = x - width - 12
  left = clampX(left)

  let y = top - height - 6
  let placement = "above"
  if (y < captionBottom) {
    const below = bottom + 6
    if (!overlaps(below, legendBox)) {
      y = below
      placement = "below"
    } else {
      const centred = (top + bottom) / 2 - height / 2
      const besideRight = x + 12
      const besideLeft = x - width - 12
      const roomVertically = !overlaps(centred, legendBox) && centred >= captionBottom
      if (roomVertically && besideRight + width <= figureWidth) {
        left = besideRight
        y = centred
        placement = "beside-right"
      } else if (roomVertically && besideLeft >= 0) {
        left = besideLeft
        y = centred
        placement = "beside-left"
      } else {
        y = -height - 6
        placement = "above-figure"
      }
    }
  }
  if (y + height > figureHeight && y >= 0) y = Math.max(figureHeight - height, captionBottom)

  return { left, top: y, placement }
}
